import { lazy } from "react";

/**
 * Flux devis :
 * - DEVIS_STANDALONE_ROUTES : pages avec layout minimal (DevisLayout), hors layout complet
 * - DEVIS_SUB_ROUTES : sous-routes de confirmation/étapes, rendues dans le layout complet
 */

const Devis = lazy(() => import("@/pages/Devis"));
const DevisConfirmation = lazy(() => import("@/pages/DevisConfirmation"));
const DevisVisite = lazy(() => import("@/pages/DevisVisite"));
const DevisVisiteConfirmation = lazy(() => import("@/pages/DevisVisiteConfirmation"));
const DevisVisio = lazy(() => import("@/pages/DevisVisio"));
const DevisVisioConfirmation = lazy(() => import("@/pages/DevisVisioConfirmation"));
const DevisDescription = lazy(() => import("@/pages/DevisDescription"));
const DevisDescriptionConfirmation = lazy(() => import("@/pages/DevisDescriptionConfirmation"));
const DevisGardeMeuble = lazy(() => import("@/pages/DevisGardeMeuble"));
const DevisGardeMeubleConfirmation = lazy(() => import("@/pages/DevisGardeMeubleConfirmation"));
const DevisMonteMeuble = lazy(() => import("@/pages/DevisMonteMeuble"));
const DevisMonteMeubleConfirmation = lazy(() => import("@/pages/DevisMonteMeubleConfirmation"));
const DevisCalculateur = lazy(() => import("@/pages/DevisCalculateur"));
const DevisCalculateurConfirmation = lazy(() => import("@/pages/DevisCalculateurConfirmation"));

export const DEVIS_STANDALONE_ROUTES = [
  { path: "/demande-de-devis", Component: Devis },
  { path: "/devis-garde-meuble", Component: DevisGardeMeuble },
  { path: "/devis-garde-meuble/confirmation", Component: DevisGardeMeubleConfirmation },
  { path: "/devis-monte-meuble", Component: DevisMonteMeuble },
  { path: "/devis-monte-meuble/confirmation", Component: DevisMonteMeubleConfirmation },
  { path: "/devis-calculateur", Component: DevisCalculateur },
  { path: "/devis-calculateur/confirmation", Component: DevisCalculateurConfirmation },
];

export const DEVIS_SUB_ROUTES = [
  { path: "/demande-de-devis/confirmation", Component: DevisConfirmation },
  { path: "/demande-de-devis/visite", Component: DevisVisite },
  { path: "/demande-de-devis/visite/confirmation", Component: DevisVisiteConfirmation },
  { path: "/demande-de-devis/visio", Component: DevisVisio },
  { path: "/demande-de-devis/visio/confirmation", Component: DevisVisioConfirmation },
  { path: "/demande-de-devis/description", Component: DevisDescription },
  { path: "/demande-de-devis/description/confirmation", Component: DevisDescriptionConfirmation },
];
